import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { HugeiconsIcon } from '@hugeicons/react'
import { Tick01Icon } from '@hugeicons-pro/core-stroke-rounded'
import { Alert, Box, List, ListItem, ListItemIcon, ListItemText, ListSubheader, useTheme } from '@mui/material'

import { selectWebStoreDrawingDoctorEnabled } from '@/app/slices/organisationSlice'

const classes = {
    listItemIconRoot: {
        minWidth: 'initial',
        paddingRight: 1.5,
    },
}

const FileRequirementsList = () => {
    const { t } = useTranslation()
    const theme = useTheme()

    const hasDrawingDoctor = useSelector(selectWebStoreDrawingDoctorEnabled)

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}
        >
            <List
                subheader={
                    <ListSubheader
                        color="primary"
                        disableSticky
                    >
                        {t('File Requirements')}
                    </ListSubheader>
                }
                disablePadding
            >
                {hasDrawingDoctor ? (
                    <>
                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="upload-2d-files"
                                primary={t('Upload 2D DXF or DWG files')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="fully-enclosed-parts"
                                primary={t('Ensure each part in the file is fully enclosed')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="convert-etching-text"
                                primary={t('Convert any etching text to shapes/outlines')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="connect-shapes-with-bridges"
                                primary={t('Connect shapes and text with bridges')}
                            />
                        </ListItem>

                        <ListItem>
                            <Alert
                                id="drawing-doctor-recommendation"
                                severity="info"
                            >
                                {t(
                                    'Use the Drawing Doctor if you need to fix scaling, split multi-part files, or remove unwanted lines or borders.'
                                )}
                            </Alert>
                        </ListItem>
                    </>
                ) : (
                    <>
                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="upload-2d-files"
                                primary={t('Upload 2D DXF or DWG files')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="include-cut-paths-only"
                                primary={t('Include cut paths only (no borders, etc.)')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="ensure-true-size"
                                primary={t('Ensure parts are scaled to their true size, 1:1')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="fully-enclosed-parts"
                                primary={t('Ensure each part in the file is fully enclosed')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="convert-etching-text"
                                primary={t('Convert any etching text to shapes/outlines')}
                            />
                        </ListItem>

                        <ListItem dense>
                            <ListItemIcon sx={classes.listItemIconRoot}>
                                <HugeiconsIcon
                                    color={theme.palette.primary.main}
                                    icon={Tick01Icon}
                                    size={20}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id="connect-shapes-with-bridges"
                                primary={t('Connect shapes and text with bridges')}
                            />
                        </ListItem>
                    </>
                )}
            </List>
        </Box>
    )
}

export default FileRequirementsList
